import { useCopilotReadable } from "@copilotkit/react-core";
import { useStore } from "@priolo/jon";
import farmSo from "stores/farm";
import natsSo from "stores/nats";
import locationSo from "stores/route/location";
import { componentToCopilot, farmToCopilot } from "./utils/toCopilot";



/**
 * indica all'AGENT che pagina sta visualizzando in questo momento ZERO-OS
 */
export function useContext() {

	useStore(locationSo)
	useStore(farmSo)

	useCopilotReadable({
		description: "Identificativo della pagina attualmente visualizzata dall'utente (page_id). Usala per capire il contesto corrente.",
		value: locationSo.state.currentPage,
		available: locationSo.state.currentPage ? "enabled" : "disabled",
	}, [locationSo.state.currentPage]);

	useCopilotReadable({
		description: "FARM disponibili. Ogni FARM: {id, name, components:[{code, name, type}]}",
		value: farmSo.state.all?.map(f => farmToCopilot(f)) ?? [],
	}, [farmSo.state.all]);

	useCopilotReadable({
		description: farmSo.state.select
			? "FARM attualmente selezionata dall'utente. Usala come contesto per le azioni successive."
			: "Nessuna FARM selezionata al momento.",
		value: farmToCopilot(farmSo.state.select),
	}, [farmSo.state.select]);

	useCopilotReadable({
		description: farmSo.state.componentSelect
			? "COMPONENT attualmente selezionato dall'utente. Il suo 'code' può essere usato nei tool di navigazione."
			: "Nessun COMPONENT selezionato al momento.",
		value: componentToCopilot(farmSo.state.componentSelect),
	}, [farmSo.state.componentSelect]);



	useCopilotReadable({
		description: `Lo stato di connessione con NATS è:`,
		value: natsSo.state.status,
	}, [natsSo.state.status]);



}


// export function usePLCContext() {

// 	useStore(valuesSo)
// 	useStore(natsSo)
// 	useStore(farmSo)

// 	const available = !!farmSo.state.select && !!farmSo.state.componentSelect && natsSo.state.status == NATS_STATUS.ONLINE ? "enabled" : "disabled"

// 	useCopilotReadable({
// 		description: `Specificando una GROWUNIT-CODEValori real-time NATS della GROWUNIT selezionata (sezione ${PAGE_ID.GROWUNIT_ADJ}).
// pH: valore di acidità dell'acqua (misura corrente, setpoint desiderato, delta = misura - setpoint).
// EC: conducibilità elettrica (fertilizzante) in mS (misura corrente, setpoint desiderato, delta = misura - setpoint).
// null = valore non ancora ricevuto da NATS.`,
// 		value: getAdjValues(),
// 		available,
// 	}, [natsSo.state.status, farmSo.state.select, farmSo.state.componentSelect, valuesSo.state.services]);

// }

// function getAdjValues() {
// 	const code = valuesSo.state.serviceCodeSel
// 	return {
// 		pH: {
// 			measured: valuesSo.getNumberByAlias({ alias: ADJ_PROPS.PH_MESURED, code }),
// 			setpoint: valuesSo.getNumberByAlias({ alias: ADJ_PROPS.PH_SETPOINT, code }),
// 			delta: valuesSo.getNumberByAlias({ alias: ADJ_PROPS.PH_DELTA, code }),
// 			unit: "pH",
// 		},
// 		EC: {
// 			measured: valuesSo.getNumberByAlias({ alias: ADJ_PROPS.EC_MESURED, code }),
// 			setpoint: valuesSo.getNumberByAlias({ alias: ADJ_PROPS.EC_SETPOINT, code }),
// 			delta: valuesSo.getNumberByAlias({ alias: ADJ_PROPS.EC_DELTA, code }),
// 			unit: "mS",
// 		},
// 	}
// }




